module.exports = "/_next/static/images/MikroTik-e8536c6c5c67c7f533718ace9c5ac781.png";